/* This file is autogenerated, see readme.md for instructions */
import LikeSvgIcon from '@bloomreach/banana-theme/icons/like.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const LikeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <LikeSvgIcon />
    </Icon>
  );
});

LikeIcon.displayName = 'LikeIcon';

export default LikeIcon;
